<template>
  <div>
    <nav class="navbar is-info has-shadow">
      <div class="container">
        <div class="navbar-brand">
          <router-link to="/" class="navbar-item">Plastic Collections</router-link>
        </div>
      </div>
    </nav>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'GuestLayout'
}
</script>

<style lang="scss" scoped>
  nav {
    margin-bottom: 1rem;
  }
</style>
